import React from "react";
import { MessageCircle } from "lucide-react";
import { waLink } from "../mock/mock";

const FloatingWhatsApp = () => (
  <a
    href={waLink("your oud collections")}
    target="_blank"
    rel="noopener noreferrer"
    aria-label="Enquire on WhatsApp"
    className="fixed bottom-6 right-6 z-[9997] group"
  >
    <span className="absolute inset-0 rounded-full bg-[var(--green)] opacity-25 animate-ping" />
    <span className="relative flex items-center gap-3 bg-[var(--green)] text-[var(--cream)] pl-4 pr-5 py-3.5 rounded-full shadow-[0_18px_40px_-16px_rgba(20,81,60,0.7)] transition-transform duration-300 group-hover:-translate-y-1">
      <MessageCircle size={20} />
      <span className="hidden sm:inline text-xs tracking-[0.16em] uppercase font-body font-medium">Enquire</span>
    </span>
  </a>
);

export default FloatingWhatsApp;
